import { observer } from "mobx-react-lite";
import MainLayout, { MAIN_RIGHT_TOP_HEIGHT } from "../MainLayout";
import { useLocation, useNavigate } from "react-router-dom";
import { VerticalLayout, HorizontalLayout } from "../../common/common-layout";
import { TitleLargeMedium, TitleMediumBold, TitleNormal } from "../../common/common-text";
import { useEffect, useState } from "react";
import BTBox from "../../common/components/BTBox";
import { BTSelectBox } from "../../common/components/BTSelectBox";
import { BTDateComponent } from "../../common/components/BTDateComponent";
import { BTCheckBox } from "../../common/components/BTCheckBox";
import BTReader from "../../common/components/board/BTReader";
import { dialogStore } from "../../store/DialogStore";
import {
    requestDeleteAllFiles,
    requestDeleteMarketingDocuments,
} from "../../service/BoardService";
import Divider from "@mui/material/Divider";
import theme from "../../common/theme";
import { formatDateToYMD } from "../../common/utils/DateUtils";

const MarketingBoardDetail = () => {
    return (
        <MainLayout>
            <MarketingBoardDetailBody />
        </MainLayout>
    );
};

export default MarketingBoardDetail;

const MarketingBoardDetailBody = observer(() => {
    const location = useLocation();
    const navigate = useNavigate();
    const [marketing, setMarketing] = useState<any>(null);
    const [marketingTypeOptions, setMarketingTypeOptions] = useState<{ label: string; value: string }[]>([]);

    useEffect(() => {
        const stateMarketing = location.state;
        if (stateMarketing?.marketing) {
            setMarketing(stateMarketing.marketing);
        }
        if (stateMarketing?.marketingTypeOptions) {
            setMarketingTypeOptions(stateMarketing.marketingTypeOptions);
        }
    }, [location.state]);

    const handleEdit = () => {
        navigate("/board/marketing/edit", {
            state: {
                marketing,
                marketingTypeOptions,
            },
        });
    };

    const handleDelete = async () => {
        const deleteConfirmed = await dialogStore.showAsyncDialog({
            title: "경고",
            message: "현재 홍보자료를 정말로 삭제하시겠습니까?",
            isCaution: true,
        });

        if (!deleteConfirmed) return;

        try {
            await requestDeleteMarketingDocuments([marketing.id]);
            await requestDeleteAllFiles("marketing", marketing.id);

            dialogStore.showDialog({
                title: "삭제 완료",
                message: "홍보자료가 삭제되었습니다.",
                onConfirm: handleBack,
                onClose: handleBack,
            });
        } catch (e) {
            console.error("홍보자료 삭제 실패", e);
            dialogStore.showDialog({
                title: "오류",
                message: "홍보자료 삭제 중 오류가 발생했습니다.",
                onConfirm: () => {},
                onClose: () => {},
            });
        }
    };

    const handleBack = () => {
        navigate('/board/marketing');
    };

    if (!marketing) return null;

    return (
        <VerticalLayout height={"auto"} paddingLeft={36} paddingRight={36}>
            <TitleLargeMedium>홍보자료 상세</TitleLargeMedium>
            <BTBox height="24px" />
            <Divider style={{ width: "100%", backgroundColor: '#D9D9D9' }} />

            <VerticalLayout height={'auto'} paddingBottom={36}>
                <TitleMediumBold style={{ marginTop: "20px" }}>홍보자료 정보</TitleMediumBold>
                <BTBox height="16px" />
                <div
                    style={{
                        display: "flex",
                        alignItems: "center",
                        gap: "16px",
                        flexWrap: "nowrap",            // 줄바꿈 방지
                        fontSize: "14px",
                        color: "#6C757D",
                    }}
                >
                    <b style={{ whiteSpace: "nowrap" }}>홍보 유형</b>
                    {/* select / date가 100% 먹지 않도록 래퍼로 폭 제어 */}
                    <div style={{ width: 260, flex: "0 0 auto" }}>
                        <BTSelectBox
                            value={marketing.marketingType}
                            readOnly
                            options={marketingTypeOptions}
                            onChange={() => {}}
                        />
                    </div>
                </div>
                <BTBox height="16px" />
                <div
                    style={{
                        display: "flex",
                        alignItems: "center",
                        gap: "16px",
                        flexWrap: "nowrap",            // 줄바꿈 방지
                        fontSize: "14px",
                        color: "#6C757D",
                    }}
                >
                    <b style={{ whiteSpace: "nowrap" }}>게시일자</b>
                    <div>{formatDateToYMD(marketing.postDate)}</div>
                    <Divider
                        orientation="vertical"
                        sx={{ borderColor: "#6C757D", mx: "4px" }}
                    />
                    <b>글 공개 여부</b>
                    <div>{marketing.isPublished ? "✅" : "❌"}</div>
                </div>

                <BTBox height='16px' />
                <Divider style={{ width: "100%", backgroundColor: '#D9D9D9' }} />
                <TitleMediumBold style={{ marginTop: "20px" }}>홍보자료 컨텐츠 정보</TitleMediumBold>
                <BTBox height='16px' />
                
                <BTReader
                    title={marketing.title}
                    contents={marketing.contents}
                    attachedFiles={marketing.attachedFiles || []}
                    createdBy={marketing.createdBy}
                    createdAt={marketing.createdAt?.toLocaleString()}
                    onEdit={handleEdit}
                    onDelete={handleDelete}
                    onBack={handleBack}
                />
            </VerticalLayout>
        </VerticalLayout>
    );
});